<template>

  <v-dialog
      v-model="show"
      :max-width="tab === 'fehl' ? '450px' : tab === 'einzel' ? '1300px' : '1100px'"
      persistent
      style="z-index: 2002"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Tätigkeit / Fehlzeit wählen</span>
      </v-card-title>
      <v-card-text>
        <v-tabs
            grow
            v-model="tab"
        >
          <v-tabs-slider color="blue" style="left: 0"></v-tabs-slider>

          <v-tab
              :key="'object'"
              :href="`#object`"
          >
            Objekt
          </v-tab>
          <v-tab
              :key="'task'"
              :href="`#task`"
          >
            Aufgabe
          </v-tab>
          <v-tab
              :key="'einzel'"
              :href="`#einzel`"
          >
            Einzelauftrag
          </v-tab>
          <v-tab
              :key="'fehl'"
              :href="`#fehl`"
          >
            Fehlzeit
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
              :key="'object'"
              :value="'object'"
          >
            <v-row>
              <v-col>
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Auftragsgruppen</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_augr"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedAugr"
                      color="indigo"
                  >
                    <template v-for="(group, i) in myList">
                      <v-divider v-if="group.title" style="border-color: rgba(0,0,0,0.46)"></v-divider>
                      <v-subheader v-if="group.title" style="margin-left: -16px">{{ group.title }}</v-subheader>
                      <v-list-item
                          v-for="(item, i) in group.items"
                          :key="item.gischl"
                          :value="item.gischl"
                          :style="{
                        'border-bottom': i === group.items.length - 1 ? 'none': 'rgba(128,128,128,0.25) thin solid',
                      }"
                      >
                        <v-list-item-content>
                          <v-row>
                            <!--v-col cols="2">
                              <v-list-item-title v-text="item.gischl"></v-list-item-title>
                            </v-col-->
                            <v-col cols="12">
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col>
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Objekte</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_object"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedAufisn"
                      color="indigo"
                  >
                    <v-list-item
                        v-for="(item, i) in filteredObjects"
                        :key="item.id"
                        :value="item.id"
                        style="border-bottom: rgba(128,128,128,0.25) thin solid;"
                    >
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="2">
                            <v-list-item-title v-text="item.aufisn"></v-list-item-title>
                          </v-col>
                          <v-col cols="6">
                            <v-list-item-title v-text="item.object"></v-list-item-title>
                          </v-col>
                          <v-col cols="4">
                            <v-list-item-title v-text="item.district"></v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item
              :key="'task'"
              :value="'task'"
          >
            <v-row style="margin-top: 8px; padding-left: 18px; padding-right: 18px">
              <v-col cols="3">
                <b-form-group
                    id="empaenger"
                    label="Aufgabe für:"
                    label-for="empaenger-select"
                >
                  <b-form-select id="empaenger-select"
                                 :plain="true"
                                 :options="planningStates"
                                 v-model="query.planning_state"
                                 size="sm"
                  style="color: black!important;">
                  </b-form-select>
                </b-form-group>
              </v-col>
              <v-col cols="5">
                <v-row>
                  <v-col cols="7" v-if="query.dateType === 'D' || query.dateType === 'W' || query.dateType === 'G'">
                    <label>{{query.dateType === 'D' ? 'Tag:' : (query.dateType === 'W' ? 'Woche:' : 'Gesamt:')}} </label>
                    <v-row style="margin: 0px">
                      <v-btn
                          style="margin-top: -4px;"
                          text
                          icon
                          color=""
                          @click="move(-1)"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>

                      <datetime
                          style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0rem; width: 140px;"
                          v-model="query.date"
                          input-class="form-control form-control-sm"
                          input-style="color: black; height: auto; padding: 0.25rem 0.5rem;
                                      font-size: 0.765625rem;
                                      line-height: 1.5;
                                      border-radius: 0.2rem;"
                          input-id="date"
                          :phrases="datetimeConfig.phrases"
                          :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                          size="sm"
                      ></datetime>
                      <v-btn
                          style="margin-top: -4px;"
                          text
                          icon
                          color=""
                          @click="move(1)"
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>

                    </v-row>
                  </v-col>
                  <v-col cols="7" v-else>
                    <label>
                      {{query.dateType === 'M' ? 'Monat:' : 'Jahr:'}}
                    </label>
                    <v-row style="margin: 0px">
                      <v-btn
                          style="margin-top: -4px;"
                          text
                          icon
                          color=""
                          @click="move(-1)"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                      <month-picker-input
                          key="month-picker"
                          v-if="query.dateType === 'M'"
                          lang="de"
                          :default-month="defaultMonth"
                          :default-year="defaultYear"
                          input-pre-filled
                          style="width: 140px"
                          @input="monthPickerChanged"
                      ></month-picker-input>
                      <month-picker-input
                          key="year-picker"
                          v-if="query.dateType === 'Y'"
                          lang="de"
                          :default-month="defaultMonth"
                          :default-year="defaultYear"
                          input-pre-filled
                          @change="monthPickerYearChanged"
                          year-only
                          style="width: 140px"
                          date-format="%Y"
                      ></month-picker-input>

                      <v-btn
                          style="margin-top: -4px;"
                          text
                          icon
                          color=""
                          @click="move(1)"
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>

                    </v-row>
                  </v-col>
                  <v-col cols="5">
                    <b-form-group
                        label="Zeitraum:"
                        label-for="date-type-select"
                    >
                      <b-form-select id="date-type-select"
                                     :plain="true"
                                     :options="dateTypes"
                                     v-model="query.dateType"
                                     size="sm"
                                     style="color: black!important;">
                      </b-form-select>
                    </b-form-group>
                  </v-col>

                </v-row>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="query.searchText"
                    prepend-icon="mdi-magnify"
                    label="Suchen"
                    single-line
                    clearable
                    style="margin-top: 12px;"
                    @input=""
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
                dense
                :headers="headerTasks"
                :items="tasks"
                :item-class="getItemClass"
                item-key="id"
                sort-by="ziel_datum"
                :expanded.sync="tasks"
                style="min-height: 45vh;"
                @click:row="onSelect"
                :no-data-text="'Keine Aufgaben gefunden'"
                :loading="loading"
                :loading-text="'Lade Aufgaben...'"
            >
              <template v-slot:item.ziel_datum="{ item }">
                <span>{{ formatDate(item.ziel_datum) }}</span>
              </template>
              <template v-slot:item.quittung_datum="{ item }">
                <span>{{ formatDate(item.quittung_datum) }}</span>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length"
                    style="box-shadow: none; border-bottom: thin solid rgba(0, 0, 0, 0.12) !important; height: 24px"
                    class="message-memo" :class="{'row-focused' : selectedTask && selectedTask.id === item.id}" @click.stop="onSelect(item)">
                  <span class="message-memo" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block; max-width: 40vw;">{{item.description}}</span>
                </td>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item
              :key="'einzel'"
              :value="'einzel'"
          >
            <v-row>
              <v-col cols="4">
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Auftragsgruppen</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_augr_einzel"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedAugrEinzel"
                      color="indigo"
                  >
                    <template v-for="(group, i) in myListEinzel">
                      <v-divider v-if="group.title" style="border-color: rgba(0,0,0,0.46)"></v-divider>
                      <v-subheader v-if="group.title" style="margin-left: -16px">{{ group.title }}</v-subheader>
                      <v-list-item
                          v-for="(item, i) in group.items"
                          :key="item.gischl"
                          :value="item.gischl"
                          :style="{
                        'border-bottom': i === group.items.length - 1 ? 'none': 'rgba(128,128,128,0.25) thin solid',
                      }"
                      >
                        <v-list-item-content>
                          <v-row>
                            <!--v-col cols="2">
                              <v-list-item-title v-text="item.gischl"></v-list-item-title>
                            </v-col-->
                            <v-col cols="12">
                              <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-col>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="8">
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Einzelaufträge</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_einzel"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedEinzel"
                      color="indigo"
                  >
                    <v-list-item
                        v-for="(item, i) in filteredEinzels"
                        :key="item.id"
                        :value="item.id"
                        style="border-bottom: rgba(128,128,128,0.25) thin solid;"
                    >
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="4">
                            <v-list-item-title v-text="item.auftrag_wo"></v-list-item-title>
                          </v-col>
                          <v-col cols="6">
                            <v-list-item-title v-text="item.auftrag_was"></v-list-item-title>
                          </v-col>
                          <v-col cols="2">
                            <v-list-item-title v-text="item.custom_properties"></v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item
              :key="'fehl'"
              :value="'fehl'"
          >
            <v-row>
              <v-col>
                <v-row style="margin: 0">
                  <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Fehlzeiten</p>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="search_fehl"
                      prepend-icon="mdi-magnify"
                      label="Suchen"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                </v-row>
                <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
                >
                  <v-list-item-group
                      v-model="selectedFehl"
                      color="indigo"
                  >
                    <v-list-item
                        v-for="(item, i) in filteredFehls"
                        :key="item.id"
                        :value="item.id"
                        style="border-bottom: rgba(128,128,128,0.25) thin solid;"
                    >
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12">
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>

              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="sendResult(true)"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="selectedAufisn === null && selectedFehl === null && selectedTask === null && selectedEinzel === null"
            v-on:click.stop="sendResult(false)"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {parseTimestamp, Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {decryptAES} from "@/shared/crypto";
import {DateTime as LuxonDateTime} from "luxon";
import { MonthPickerInput } from 'vue-month-picker'

import Chevron from 'vue-material-design-icons/ChevronDown.vue';
import DayIcon from 'vue-material-design-icons/AlphaTBoxOutline.vue';
import WeekIcon from 'vue-material-design-icons/AlphaWBoxOutline.vue';
import MonthIcon from 'vue-material-design-icons/AlphaMBoxOutline.vue';
import YearIcon from 'vue-material-design-icons/AlphaJBoxOutline.vue';
import AllIcon from 'vue-material-design-icons/CodeLessThanOrEqual.vue';


import ChLeft from 'vue-material-design-icons/ChevronLeft';
import ChRight from 'vue-material-design-icons/ChevronRight';
export default {
  name: "SelectTaskDialog",
  components: {
    Chevron, DayIcon,
    WeekIcon, MonthIcon, YearIcon,
    AllIcon, MonthPickerInput, ChLeft, ChRight},
  props: {
    currentMita: {
      type: Object,
      default: () => undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    augrs: {
      type: Array,
      default: () => []
    },
    objectMap: {
      type: Object,
      default: () => ({})
    },
    fehls: {
      type: Array,
      default: () => []
    },
    kostMapping: {
      type: Array,
      default: () => []
    },
    migrMapping: {
      type: Array,
      default: () => []
    },
    einzelMap: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    selectedAugr: null,
    selectedAufisn: null,
    selectedTask: null,
    selectedFehl: null,
    selectedEinzel: null,
    selectedAugrEinzel: null,
    tab: 'object',
    show: false,
    search_augr: '',
    search_fehl: '',
    search_object: '',
    search_augr_einzel: '',
    search_einzel: '',
    datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
    headerAugrs: [
      { text: 'augr', value: 'gischl' },
      { text: 'Auftragsgruppe', value: 'name' },
    ],
    headerObjects: [
      { text: 'aufisn', value: 'aufisn' },
      { text: 'Objekte', value: 'object' },
      { text: 'Ortsteil', value: 'district' },
    ],
    headerFehls: [
      { text: 'Auftragsgruppe', value: 'name' },
    ],
    headerTasks: [
      { text: 'Betreff', value: 'auftrag_wo' },
      { text: 'Auftrag Was', value: 'auftrag_was' },
      { text: 'Ziel', value: 'ziel_datum' },
      { text: 'Annahme', value: 'quittung_datum' },
    ],
    tasks: [],
    query: {
      planning_state: "U",
      date: LuxonDateTime.local().toISO(),
      dateType: "W",
      searchText: "",
    },
    planningStates: [
      { text: '', value: 'U' },
      { text: 'Unerheblich', value: 'P' },
    ],
    dateTypes: [
      { value: 'D', text: 'Tag' },
      { value: 'W', text: 'Woche' },
      { value: 'M', text: 'Monat' },
      { value: 'Y', text: 'Jahr' },
      { value: 'G', text: 'Gesamt <=' },
    ],
    expanded: [],
    loading: false,
    loadedOnce: false,
  }),
  computed: {
    defaultMonth() {
      return LuxonDateTime.fromISO(this.query.date).month;
    },
    defaultYear() {
      return LuxonDateTime.fromISO(this.query.date).year;
    },
    filteredObjects() {
      if (!this.selectedAugr) {
        return [];
      }
      let res = this.objectMap[this.selectedAugr] || [];
      if (this.search_object && this.search_object.length > 0) {
        const search = this.search_object.toLowerCase();
        res = res.filter(obj => obj.aufisn.toLowerCase().includes(search) || obj.object.toLowerCase().includes(search) || obj.district.toLowerCase().includes(search));
      }
      return res;
    },
    filteredEinzels() {
      if (!this.selectedAugrEinzel) {
        return [];
      }
      let res = this.einzelMap[this.selectedAugrEinzel] || [];
      if (this.search_einzel && this.search_einzel.length > 0) {
        const search = this.search_einzel.toLowerCase();
        res = res.filter(obj => obj.auftrag_wo.toLowerCase().includes(search) || obj.auftrag_was.toLowerCase().includes(search) || obj.custom_properties.toLowerCase().includes(search));
      }
      return res;
    },
    filteredFehls() {
      let res =  [...this.fehls];
      res.push({
        id: 'PAUSE',
        name: 'Pause',
        access: 'PAUSE'
      });
      res.sort((a, b) => a.name.localeCompare(b.name));
      if (this.search_fehl && this.search_fehl.length > 0) {
        const search = this.search_fehl.toLowerCase();
        res = res.filter(fehl => fehl.name.toLowerCase().includes(search));
      }
      return res;
    },
    currentKostMapping() {
      if (!this.kostMapping || this.kostMapping.length === 0 || !this.currentMita || !this.currentMita.kost) {
        return [];
      }
      // filter kostMapping for current mita kost
      return this.kostMapping.filter(km => km.key === this.currentMita.kost);
    },
    currentMigrMapping() {
      if (!this.migrMapping || this.migrMapping.length === 0 || !this.currentMita || !this.currentMita.migr) {
        return [];
      }
      // filter migrMapping for current mita migr
      return this.migrMapping.filter(mm => mm.key === this.currentMita.migr);
    },
    currentMapping() {
      if (this.currentMigrMapping.length > 0) {
        return this.currentMigrMapping;
      } else if (this.currentKostMapping.length > 0) {
        return this.currentKostMapping;
      } else {
        return [];
      }
    },
    myList() {
      // first apply the search filter
      let filtered = this.augrs;
      if (this.search_augr && this.search_augr.length > 0) {
        const search = this.search_augr.toLowerCase();
        filtered = filtered.filter(augr => augr.name.toLowerCase().includes(search));
      }
      let preselect = {
        title: 'Vorauswahl',
        items: []
      }
      let rest = {
        title: 'Weitere Auftragsgruppen',
        items: []
      }
      let list = [];
      for (let i = 0; i < filtered.length; i++) {
        let cur = filtered[i];
        let mappingIndex = this.currentMapping.findIndex(lm => lm.value === cur.gischl);
        if (mappingIndex !== -1) {
          preselect.items.push(cur);
        }  else {
          rest.items.push(cur);
        }
      }
      // order list by text
      list.sort((a, b) => a.title.localeCompare(b.title));
      // prepend preselect and append rest
      if (preselect.items.length > 0) {
        list.unshift(preselect);
      }
      if (list.length === 0) {
        rest.title = '';
      }
      if (rest.items.length > 0) {
        list.push(rest);
      }
      return list;
    },
    myListEinzel() {
      // first apply the search filter
      let filtered = this.augrs.filter(augr => this.einzelMap.hasOwnProperty(augr.gischl));
      if (this.search_augr_einzel && this.search_augr_einzel.length > 0) {
        const search = this.search_augr_einzel.toLowerCase();
        filtered = filtered.filter(augr => augr.name.toLowerCase().includes(search));
      }
      let preselect = {
        title: 'Vorauswahl',
        items: []
      }
      let rest = {
        title: 'Weitere Auftragsgruppen',
        items: []
      }
      let list = [];
      for (let i = 0; i < filtered.length; i++) {
        let cur = filtered[i];
        let mappingIndex = this.currentMapping.findIndex(lm => lm.value === cur.gischl);
        if (mappingIndex !== -1) {
          preselect.items.push(cur);
        }  else {
          rest.items.push(cur);
        }
      }
      // order list by text
      list.sort((a, b) => a.title.localeCompare(b.title));
      // prepend preselect and append rest
      if (preselect.items.length > 0) {
        list.unshift(preselect);
      }
      if (list.length === 0) {
        rest.title = '';
      }
      if (rest.items.length > 0) {
        list.push(rest);
      }
      return list;
    },
  },
  watch: {
    tab(newVal) {
      this.selectedAufisn = null;
      this.selectedAugr = null;
      this.selectedFehl = null;
      this.selectedTask = null;
      this.selectedEinzel = null;
      this.selectedAugrEinzel = null;
    },
    'query.date'(newVal) {
      this.queryUserTasks();
    },
    'query.dateType'(newVal) {
      this.queryUserTasks();
    },
    'query.planning_state'(newVal) {
      this.queryUserTasks();
    },
    'query.searchText'(newVal) {
      this.queryUserTasks();
    },
  },
  methods: {
    sendResult(cancel = false) {
      if (cancel) {
        this.show = false;
        return
      }
      let res = {
        augr: cancel ? null : this.selectedAugr,
        aufisn: cancel ? null : this.selectedAufisn,
        task: cancel ? null : this.selectedTask,
        fehl: cancel ? null : this.selectedFehl,
        einzel: cancel ? null : (this.selectedEinzel ? this.einzelMap[this.selectedAugrEinzel].filter( e => e.id === this.selectedEinzel)[0] : null),
      };
      this.$emit('selected-task', res);
      this.show = false;
    },
    openDialog() {
      this.planningStates[0].text = this.currentMita.name;
      this.selectedAugr = null;
      this.selectedAufisn = null;
      this.selectedTask = null;
      this.selectedFehl = null;
      this.tab = 'object';
      this.queryUserTasks(true);
      this.show = true;
    },
    getItemClass(item) {
      if (this.selectedTask && item.id === this.selectedTask.id) {
        return 'row-focused';
      }
      return '';
    },
    onSelect(item) {
      this.selectedTask = item;
    },
    queryUserTasks(ignoreLoadedOnce = false) {
      if (!ignoreLoadedOnce && !this.loadedOnce) {
        return;
      }
      this.loading = true;
      let d = parseTimestamp(new Date(Date.parse(this.query.date)), "DD.MM.YYYY")
      d = encodeURIComponent(d)
      this.$http.get(
          Server_URL_ZK+'/zk/user_tasks/'+this.currentMita.bis_id + "-"+
          "?selected_start_date="+d+
          "&selected_date_type="+this.query.dateType+
          "&planning_state="+this.query.planning_state+
          "&search_text="+encodeURIComponent(this.query.searchText)
      ).then(this.responseOkFetch, this.responseError)
    },
    responseOkFetch(response) {
      if (response.status === 200 ) {
        let data = response.body;
        this.decryptData(data);
        this.loading = false;
        this.loadedOnce = true;
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    formatDate(date) {
      return parseTimestamp(new Date(Date.parse(date)), "DD.MM.YYYY");
    },
    async decryptData(data) {
      for (let i = 0; i < data.length; i++) {
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
          //data[i].ziel_datum = parseTimestamp(new Date(Date.parse(data[i].ziel_datum)), "DD.MM.YYYY");
          //data[i].quittung_datum = parseTimestamp(new Date(Date.parse(data[i].quittung_datum)), "DD.MM.YYYY");
        } catch (e) {
          //console.log(e)
        }
      }
      this.tasks = data;
    },
    responseError(response) {
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    monthPickerChanged({monthIndex, year}) {
      let yearDiff = year - this.defaultYear;
      let monthDiff = monthIndex - this.defaultMonth;
      let date = LuxonDateTime.fromISO(this.query.date);
      date = date.plus({years: yearDiff, months: monthDiff});
      this.query.date = date.toISO();
    },
    monthPickerYearChanged({monthIndex, year}) {
      let yearDiff = year - this.defaultYear;
      let date = LuxonDateTime.fromISO(this.query.date);
      date = date.plus({years: yearDiff});
      this.query.date = date.toISO();
    },
    move(direction) {
      let date = LuxonDateTime.fromISO(this.query.date);
      if (this.query.dateType === "D" || this.query.dateType === "G") {
        date = date.plus({days: direction});
      } else if (this.query.dateType === "W") {
        date = date.plus({weeks: direction});
      } else if (this.query.dateType === "M") {
        date = date.plus({months: direction});
      } else if (this.query.dateType === "Y") {
        date = date.plus({years: direction});
      }
      this.query.date = date.toISO();
    },
  }
}
</script>

<style scoped>

::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > .v-data-table__expanded__row > td {
  border: none !important;
}

::v-deep .test-start:has(> .v-data-table__expanded__row) {
  border: none;
}

::v-deep .v-data-table__expanded__content {
  box-shadow: none !important;
  cursor: pointer;
}

::v-deep  .v-data-table__expanded__row {
  background-color: white !important;
}

.message-memo {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #5f6368;
  font-weight: normal;
  vertical-align: sub;
}

::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  width: 140px;
}

::v-deep .v-data-table__wrapper {
  min-height: 39vh;
}

</style>
